var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "order-btn" },
        [
          _c(
            "vxe-button",
            {
              on: {
                click: function ($event) {
                  return _vm.returnFun()
                },
              },
            },
            [_vm._v("返回")]
          ),
          _c(
            "vxe-button",
            {
              attrs: { status: "primary" },
              on: { click: _vm.debounceCommitFun },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
      _c("a-divider"),
      _c("div", { staticClass: "orderFormLine" }, [_vm._v("订单信息")]),
      _c(
        "div",
        { staticClass: "budgetBox" },
        [
          _c(
            "a-form-model",
            {
              ref: "orderForm",
              staticClass: "UniformCss",
              attrs: {
                inline: true,
                model: _vm.order,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: { label: "订单编号", prop: "applyOrderCode" },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.applyOrderCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyOrderCode", $$v)
                              },
                              expression: "order.applyOrderCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "申领部门", prop: "orgName" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orgName,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orgName", $$v)
                              },
                              expression: "order.orgName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "申领人", prop: "applyMan" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.applyMan,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyMan", $$v)
                              },
                              expression: "order.applyMan",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "申领日期", prop: "applyTime" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.applyTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "applyTime", $$v)
                              },
                              expression: "order.applyTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "订单总项数",
                            prop: "orderMaterialCount",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orderMaterialCount,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orderMaterialCount", $$v)
                              },
                              expression: "order.orderMaterialCount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "订单总数量", prop: "orderNums" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orderNums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orderNums", $$v)
                              },
                              expression: "order.orderNums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "订单总金额",
                            prop: "orderTotalSums",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.order.orderTotalSums,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "orderTotalSums", $$v)
                              },
                              expression: "order.orderTotalSums",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "收货人", prop: "receiver" } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { placeholder: "收货人", clearable: "" },
                              on: { change: _vm.diseaseChange },
                              model: {
                                value: _vm.order.receiver,
                                callback: function ($$v) {
                                  _vm.$set(_vm.order, "receiver", $$v)
                                },
                                expression: "order.receiver",
                              },
                            },
                            _vm._l(_vm.romotionOrderStatus, function (item) {
                              return _c(
                                "a-select-option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.recipientName))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "收货人联系方式",
                            prop: "receivePhone",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: "", clearable: "" },
                            model: {
                              value: _vm.order.receivePhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "receivePhone", $$v)
                              },
                              expression: "order.receivePhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "收货地址", prop: "address" } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "收货地址",
                              disabled: "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.order.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.order, "address", $$v)
                              },
                              expression: "order.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "padding-bottom": "1px",
                  },
                },
                [
                  _c(
                    "vxe-button",
                    {
                      staticStyle: { "margin-top": "1px" },
                      attrs: { status: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveOrderInfo("orderForm")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "orderFormLine" },
        [
          _vm._v("物料信息 "),
          !_vm.order.id
            ? _c(
                "a-tooltip",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [_vm._v("保存订单后显示添加物料按钮")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1285516201
                  ),
                },
                [_c("a-icon", { attrs: { type: "info-circle" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "budgetBox" }, [
        _c(
          "div",
          { staticStyle: { padding: "10px 0" } },
          [
            _vm.btnEnable
              ? _c("vxe-button", { on: { click: _vm.addMateWu } }, [
                  _vm._v("添加"),
                ])
              : _vm._e(),
            _vm.btnEnable
              ? _c(
                  "vxe-button",
                  {
                    attrs: { status: "primary" },
                    on: { click: _vm.handleDelete },
                  },
                  [_vm._v("删除")]
                )
              : _vm._e(),
            _c("SelectMaterialDialog", {
              attrs: { visible: _vm.dialogVisible },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
                addMaterial: _vm.addMaterial,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "vxe-table",
              {
                ref: "xTable",
                attrs: {
                  border: "",
                  resizable: "",
                  stripetrue: "",
                  "keep-source": "",
                  "show-header-overflow": "",
                  "show-overflow": "",
                  "max-height":
                    _vm.$store.state.app.height - 170 < 300
                      ? 300
                      : _vm.$store.state.app.height - 170,
                  align: "center",
                  data: _vm.tableData,
                  "edit-config": {
                    trigger: "manual",
                    mode: "row",
                    autoClear: false,
                    showStatus: true,
                  },
                },
              },
              [
                _c("vxe-column", { attrs: { type: "checkbox", width: "40" } }),
                _c("vxe-column", {
                  attrs: { type: "seq", title: "序号", width: "60" },
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "materialCode",
                    title: "物料号",
                    width: "150",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "materialName",
                    title: "物料名称",
                    width: "250",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "materialType",
                    title: "物料类型",
                    width: "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.materialType === "1"
                            ? _c("span", [_vm._v("销售物料")])
                            : row.materialType === "2"
                            ? _c("span", [_vm._v("礼品物料")])
                            : row.materialType === "3"
                            ? _c("span", [_vm._v("宣传物料")])
                            : row.materialType === "4"
                            ? _c("span", [_vm._v("其它")])
                            : row.materialType === "5"
                            ? _c("span", [_vm._v("产品资料")])
                            : row.materialType === "6"
                            ? _c("span", [_vm._v("手册")])
                            : _c("span", [_vm._v(_vm._s(row.materialType))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: { field: "storage", title: "数量", width: "80" },
                }),
                _c("vxe-column", {
                  attrs: { field: "price", title: "申领价", width: "80" },
                }),
                _c("vxe-column", {
                  attrs: { field: "nums", title: "申领数量", width: "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("vxe-input", {
                            attrs: {
                              type: "number",
                              min: "0",
                              max: row.storage,
                              placeholder: "请输入数量",
                            },
                            model: {
                              value: row.nums,
                              callback: function ($$v) {
                                _vm.$set(row, "nums", $$v)
                              },
                              expression: "row.nums",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "totalSums",
                    title: "申领总金额",
                    width: "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", [_vm._v(_vm._s(_vm.countTotalSums(row)))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "applyRemarks",
                    title: "申领用途",
                    width: "250",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("vxe-input", {
                            attrs: { type: "text" },
                            model: {
                              value: row.applyRemarks,
                              callback: function ($$v) {
                                _vm.$set(row, "applyRemarks", $$v)
                              },
                              expression: "row.applyRemarks",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "a-modal",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.appdialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.appdialogVisible = $event
            },
            cancel: function ($event) {
              _vm.appdialogVisible = false
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            model: {
              value: _vm.approveMsg,
              callback: function ($$v) {
                _vm.approveMsg = $$v
              },
              expression: "approveMsg",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary", loading: _vm.approveBtnLoading },
                  on: {
                    click: function ($event) {
                      return _vm.approveLiuCheng()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.submitName))]
              ),
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.appdialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }